<template>
  <li
    class="main-item point"
    @click="$emit('changeActiveComponent')"
  >
    <a
      class="main-item-link point"
      :class="{ active: isActive }"
    >
      Browse by name
      <img
        class="icon"
        src="../../../images/down-arrow.svg"
        alt=""
      >
    </a>

    <ul
      ref="scrollableComponent"
      class="sub-list hide"
      :class="{ show: isActive }"
      @scroll="handleScroll"
    >
      <li
        v-for="lawyer in lawyers"
        :key="lawyer.id"
        class="sub-list-item"
      >
        <router-link
          :to="{ name: 'ShowLawyer', params: { id: lawyer.user_detail.id } }"
          class="name"
        >
          {{ getLawyerName(lawyer) }}
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
import {ref, computed, onMounted} from 'vue'
import {auth} from '@/api-services'
import {parseLinkHeader, paginationHandler} from '@/utils/common'

export default {
  name: 'BrowseByName',
  props: {
    active: {
      type: String,
      default: 'ByName',
    },
  },
  setup(props) {
    const lawyers = ref([])
    const links = ref({})
    const scrollableComponent = ref(null)

    const isActive = computed(() => props.active === 'ByName')

    onMounted(() => {
      auth.getAllLawyer()
        .then((res) => {
          links.value = parseLinkHeader(res.headers.link)
          lawyers.value = res.data
          if (links.value.next) {
          getNextPage()
        }
        })
    })

    const getLawyerName = (lawyer) => {
      const firstName = lawyer.user_detail.first_name
      const middleName = lawyer.user_detail.middle_name
      const lastName = lawyer.user_detail.last_name

      if (middleName) {
        return `${firstName} ${middleName} ${lastName}`
      }

      return `${firstName} ${lastName}`
    }

    const handleScroll = () => {
      const scrollElement = scrollableComponent.value
      const scrollHeight = scrollElement.scrollHeight
      const scrollTop = scrollElement.scrollTop
      const clientHeight = scrollElement.clientHeight

      if (scrollTop + clientHeight >= scrollHeight) {
        if (links.value.next) {
          getNextPage()
        }
      }
    }

    const getNextPage = async () => {
      const response = await paginationHandler(links.value.next)
      lawyers.value = [...lawyers.value, ...response.data]
      links.value = parseLinkHeader(response.headers.link)
    }

    return {
      lawyers,
      isActive,
      scrollableComponent,
      getLawyerName,
      handleScroll,
    }
  },
}
</script>
<style lang="scss" scoped>
.sub-list {
  max-height: 350px;
  margin: 1rem 0;
  overflow-y: auto;
  padding: 0 2rem;

  .sub-list-item {
    margin-bottom: 0;
    float: left;
    width: calc(100% / 4);
    padding-right: 30px;

    .name {
      margin: 10px 0 0;
    }
  }
}
@media (max-width: 767px) {
  .sub-list {
    .sub-list-item {
      width: calc(100% / 2);
    }
  }
}
@media (max-width: 499px) {
  .sub-list {
    .sub-list-item {
      width: calc(100% / 2);
    }
  }
}
@media (max-width: 400px) {
  .sub-list {
    .sub-list-item {
      width: calc(100% / 1);
      padding-right: 0;
    }
  }
}
</style>
